<template>
  <f7-page>
    <div class="main-content h-100">
      <b-container :class="{'w-60' : getCols < 5}">
        <div class="d-flex align-items-center justify-content-center h-100vh">
            <b-row align-h="start" :cols="getCols">
              <b-col v-for="(action, index) in data" :key="action.id">
                <b-container class="homeButton" :class="getColor(index)" @click="redirect(action.link)" fluid>
                    <b-row>
                        <b-col cols="9"><i :class="action.icon" class="homeButtonIcon fa"></i></b-col>
                    </b-row>
                    <b-row class="d-flex-end h-50">
                        <b-col cols="9"><div class="w-100 fs-16px text-white">{{ $t(action.title) }}</div></b-col>
                    </b-row>
                </b-container>
              </b-col>
            </b-row>
        </div>
      </b-container>
  </div>
  </f7-page>
</template>

<script>
import buttonsData from '@/pages/user/data/homepageData.json'
import _ from 'lodash'
import Img from '../../assets/static/images/homepage/accueil.jpg'
import Logo from './../../assets/static/images/StreamMind_horizontal.png'
import {loadPage} from '@/helpers/routing'
import MoneyRoadLogo from '../../assets/static/images/homepage/moneyroad_texte_seul.png'
import { tr } from 'vuejs-datepicker/src/locale'

/* import font awesome icon component */
/* import specific icons */

export default {
  name: 'Homepage',
  components: {
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  computed: {
    getCols () {
      if (this.data.length < 5) {
        if (this.data.length < 2) {
          return '1'
        } else {
          return '2'
        }
      }
      return '3'
    }
  },
  data () {
    return {
      data: [],
      imgLogo: Logo,
      MrBgLogo: MoneyRoadLogo,
      nbButtons: 0,
      nbMaxItem: 3,
      nbMaxColor: 4,
      color: ['#4CD8C4','#F59655','#FA7C57','#EE89A6'],
      colors: ['0'],
     }
  },
  created () {
    this.$bus.emit('isOnHomepage', true)
    this.$$('.homepageNavbar').removeClass('deleteNavBar')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: ''
    })
    let availableButtons = []
    let that = this
    buttonsData.buttons.forEach(item => {
      if (!item.disabled && this.hasRight(item.right)) {
        that.getCardClass
        item.class = that.getCardClass(item) + ' ' + item.class
        availableButtons.push(item)
      }
    })
    let dataCopy = availableButtons.filter(elem => that.hasRight(elem.right))
    let settingsFound = false
    let settingsRtpFound = false
    dataCopy.forEach((item => {
      if (item.id === 3) {
        settingsFound = true
      }

      if (item.id === 4) {
        settingsRtpFound = true
      }
    }))

    if(settingsFound === true && settingsRtpFound === true) {
      dataCopy = dataCopy.filter(elem => elem.id !== 3)
    }
    this.data = dataCopy
    if (this.data.length < this.nbMaxItem) {
      this.nbMaxItem = this.data.length
    }


  },
  mounted () {
    this.tryRedirect()
  },
  methods: {
    tryRedirect () {
      let previousPage = this.$f7.getCurrentView().history[this.$f7.getCurrentView().history.length - 1]
      if (previousPage === '/login/') {
        this.$bus.emit('refresh-cache-menu')
      }
    },
    getColor(index) {
      // Récupérer la couleur en fonction de l'index
      return 'card-color-' + (index % this.color.length)
    },
    getCardClass (button) {
      this.nbButtons++
      return ('homeCardBody-' + ((this.nbButtons % this.nbMaxColor) + 1))
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, true)
    },
    redirect (url) {
      loadPage(this, { url: url })
    },
    test () {
      console.log('data', this.data)
    }
  }
}
</script>
<style scoped>

.main-content {
  background-color: #FFFFFF;
}

@media (max-width:991px) {
  .main-content {
    height: calc(100% - 44px);
  }
}

</style>
